// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__29hHD","footer":"Form_footer__33b0w"};